"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReduxMountPoint = getReduxMountPoint;
exports.DEFAULT_REDUX_MOUNT_POINT = exports.REDUX_MOUNT_POINT = void 0;
var REDUX_MOUNT_POINT = '_reduxMountPoint';
exports.REDUX_MOUNT_POINT = REDUX_MOUNT_POINT;
var DEFAULT_REDUX_MOUNT_POINT = 'inputs';
exports.DEFAULT_REDUX_MOUNT_POINT = DEFAULT_REDUX_MOUNT_POINT;

function getReduxMountPoint(inputConfig) {
  return inputConfig[REDUX_MOUNT_POINT] || DEFAULT_REDUX_MOUNT_POINT;
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/util/mountPoint.js
// module id = 161
// module chunks = 0